import { stringify } from 'qs';
import request from '../fetchRequest';
import { url } from '../service-utils';

// 获取消息列表
export async function getMessage(params) {
  return request(`${url.settingApi}/message/config/org/app/list?${stringify(params)}`);
}

// 消息推送设置
export async function saveMessage(params) {
  return request(`${url.settingApi}/message/config/org/app/msg/control`, {
    method: 'post',
    data: params,
  });
}
